import React, { useRef } from "react";
import styled from "styled-components";
import { ReactComponent as ChevronRed } from "../../assets/chevron-red.svg";

// max-width: 712px;
const FaqAccordionStyle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 45px;
  background: #fcfcfc;
  width: 100%;
  margin: auto;
  border-radius: 18.75px;
  /* background: #fff; */
  transition: all 0.3s;
  &.show {
    background: rgba(174, 0, 0, 0.1);
    .accordion__header {
      margin-bottom: 11.5px;
    }
    .icon {
      transform: rotate(90deg);
      circle {
        fill: #fff;
        stroke-width: 0.75px;
        stroke: #ae0000;
      }
      path {
        fill: #ae0000;
      }
    }
  }
  .accordion__header {
    display: flex;
    align-items: center;
    gap: 24px;
    cursor: pointer;
    .icon {
      display: block;
      transition: all 0.3s;
      .circle,
      path {
        transition: all 0.3s;
      }
    }
    .accordion__title {
      color: #303030;
      font-size: 18px;
      font-weight: 600;
      line-height: 22.5px;
      cursor: pointer;
    }
  }
  .accordion__body {
    color: #303030;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.5px; /* 150% */
    height: 0px;
    opacity: 0;
    overflow: clip;
    padding-left: 49px;
    transition: all 0.3s;
  }
  @media (max-width: 678px) {
    padding: 12px;
    &.show {
      .accordion__header {
        margin-bottom: 8px;
      }
    }
    .accordion__header {
      gap: 12px;
      .icon {
        width: 20px;
        path {
          transform: translate(-5px, -6px) scale(1.5);
        }
      }
      .accordion__title {
        font-size: 14px;
      }
    }
    .accordion__body {
      font-size: 13px;
      line-height: 20px;
      padding-left: 33px;
    }
  }
`;

const FaqAccordion = ({ question, answer, isOpen, onToggle }) => {
  const contentRef = useRef(null);

  return (
    <FaqAccordionStyle className={`${isOpen ? "show" : "hide"}`}>
      <div className="accordion__header" onClick={onToggle}>
        <ChevronRed className="icon" />
        <h2 className="accordion__title" onClick={onToggle}>
          {question}
        </h2>
      </div>
      <div
        className={`accordion__body`}
        ref={contentRef}
        style={{
          height: isOpen ? contentRef.current?.scrollHeight : 0,
          opacity: isOpen ? 1 : 0,
        }}
      >
        {answer}
      </div>
    </FaqAccordionStyle>
  );
};

export default FaqAccordion;
